import {useMultiStyleConfig} from '@chakra-ui/react';
import {createMultiStyleConfigHelpers, defineStyle} from '@chakra-ui/styled-system';
import type {ChakraStylesConfig} from 'chakra-react-select';

import {inputTheme} from './Input';

type Parts = keyof ChakraStylesConfig;
const parts = [
  `container`,
  `control`,
  `input`,
  `valueContainer`,
  `downChevron`,
  `clearIndicator`,
  `indicatorsContainer`,
  `indicatorSeparator`,
  `dropdownIndicator`,
  `menuList`,
] satisfies Array<Parts>;
const {defineMultiStyleConfig, definePartsStyle} = createMultiStyleConfigHelpers(parts);

const baseStyleField = defineStyle({
  ...inputTheme.baseStyle?.field,
});

const baseStyle = definePartsStyle({
  // TODO: diff between input and select
  valueContainer: baseStyleField,
  control: baseStyleField,
  clearIndicator: {
    fontSize: `inherit`,
  },
  downChevron: {
    fontSize: `inherit`,
  },
  dropdownIndicator: {
    bgColor: `transparent`,
  },
  indicatorSeparator: {
    opacity: `0`,
  },
  indicatorsContainer: {
    px: `space-150`,
  },
  menuList: {
    borderRadius: `radius-200`,
    border: 0,
    boxShadow: `xl`,
  },
});

const iconSpacing = defineStyle({});

const sizes = {
  lg: {
    control: {
      ...inputTheme.sizes?.lg.field,
    },
    inputContainer: {
      ...inputTheme.sizes?.lg.field,
    },
  },
  md: {
    inputContainer: {
      ...inputTheme.sizes?.md.field,
    },
    control: {
      ...inputTheme.sizes?.md.field,
      ...iconSpacing,
    },
  },
  sm: {
    control: {
      ...inputTheme.sizes?.sm.field,
      display: `flex`,
      justifyContent: `center`,
      alignItems: `center`,
      alignSelf: `stretch`,
      paddingLeft: `space-050`,
    },
  },
};

export const avatarSelectTheme = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants: {},
  defaultProps: {
    size: `lg`,
  },
});

export const useAvatarSelectStyleConfig = (props?: Parameters<typeof useMultiStyleConfig>[1]) => {
  const path = `AvatarSelect`;
  // @ts-expect-error: TODO: fix this
  return useMultiStyleConfig(path, props ?? {}) as PartsStyleObject<{keys: Parts}>;
};
